import AuthenticatedUserContext, {
	type AuthenticatedUserContextValue,
} from '@UI/Providers/AuthenticatedUserProvider/AuthenticatedUserContext';
import * as React from 'react';

function useAuthenticatedUser(): AuthenticatedUserContextValue {
	const context = React.useContext(AuthenticatedUserContext);

	if (context === null) {
		throw new Error('useAuthenticatedUser must be used within an AuthenticatedUserProvider.');
	}

	return context;
}

export default useAuthenticatedUser;
